import React, { useEffect, useState } from "react";
import NormalTable from "../../../components/common/Tables/NormalTable";
import { getAllVenueBySlug, getReport, getTicketTypeBySlug,getAllTicketGroupBySlug } from "../../../api";
import { PulseLoader } from 'react-spinners';
import ExportToExcel from "../../../components/ExportToExcel/ExportToExcel";
import { number } from "yup";
import { handleError } from "../../../utils/errorHandler";
import { useNavigate } from "react-router-dom";


const UserTicketReport = () => {
  const [bookingStatus, setBookingStatus] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [originalBookingStatus, setOriginalBookingStatus] = useState<any[]>([]);
  const [exportBookingStatus, setExportBookingStatus] = useState<any[]>([]);
  const [selectedVenue, setSelectedVenue] = useState<string>("");
  const [eventVenues, setEventVenues] = useState<any[]>([]);
  const [hasGroupTickets, setHasGroupTickets] = useState(false);
  const [groupTicketList, setGroupTicketList] = useState<any[]>([]);
  const [selectedGroupSorting, setSelectedGroupSorting] = useState("0");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTicketBuyers,setSelectedTicketBuyers] = useState<any>(null);
  const navigate = useNavigate();
  type TicketRow = {
    groupName: string;
    ticketType: string;
    price: number;
    totalTicketsSold: number;
    isGroupTicket: boolean;
    ticketStatus: string;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const eventData = localStorage.getItem("eventData");
        console.log("eventData", eventData);
        if (eventData) {
          const eventSlug = JSON.parse(eventData).slugId;
          const venueId = localStorage.getItem("venueId");
          const response = await getTicketTypeBySlug(eventSlug);
          const filteredResponse = response.filter((item: any) => item.venueId === venueId);
          setBookingStatus(filteredResponse);
          setOriginalBookingStatus(filteredResponse);
        }
      } catch (error) {
        console.error("Error fetching attendee report:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
    getEventVenue();
    GroupTickets();
  }, []);
  const getEventVenue = async () => {
    try {
      const eventData = localStorage.getItem("eventData");
      if (!eventData) return;
      const slugId = JSON.parse(eventData).slugId;
      const resp = await getAllVenueBySlug(slugId);
      const venueOptions = resp.map((item:any) => {
        return {
          value: item.venueId,
          label: item.venueName
        }
      })
      const allVenue = {
        value:0,
        label:"All Venues"
      }
      setEventVenues([allVenue,...venueOptions])
    } catch (error) {
      handleError(error)
    }
  }
  const handleViewBuyers = (ticketTypeId: string, groupName: string, ticketType: string) => {
    const eventData = localStorage.getItem("eventData");
    if (!eventData) return;

    const parsed = JSON.parse(eventData);
    const eventId = parsed.eventId;

    navigate(`/event/reports/ticket-buyer-details`, {
      state: {
        eventId,
        ticketTypeId,
        groupName,
        ticketType,
      },
    });
  };
  const GroupTickets = async () => {
      const eventData = localStorage.getItem("eventData");
      if (eventData) {
        const eventSlug = JSON.parse(eventData).slugId;
        const groupTickets = await getAllTicketGroupBySlug(eventSlug);
        if (groupTickets && groupTickets.length > 0) {
          const groupOptions = groupTickets.map((group: any) => ({
            value: group.id,
            label: group.groupName,
          }));
          setHasGroupTickets(true);
          setGroupTicketList(groupOptions);
        }
      }
    }
  const columns = [
    { label: "Group Name", key: "groupName" },
    { label: "Ticket Type", key: "ticketType" },
    { label: "Ticket Price", key: "price" },
    {
      label: "Ticket Sold", key: "totalTicketsSold",
      cellContent: (row: any) => {
        const isGroup = row?.isGroupTicket;
        const groupCount = row?.groupTicketCount;
        let totalTicketsSold = 0;
    
        if (isGroup && groupCount > 0) {
          totalTicketsSold = Number(row?.totalTicketsSold) / Number(groupCount);
        } else {
          totalTicketsSold = row?.totalTicketsSold || 0;
        }
    
        return (
          <div className="d-flex align-items-center gap-2">
            <span>{totalTicketsSold}</span>
            <button
              className="btn btn-sm btn-primary"
              onClick={(e) => {
                e.stopPropagation();
                handleViewBuyers(row.ticketTypeId, row.groupName, row.ticketType);
              }}
            >
              View
            </button>
          </div>
        );
      }
    },

    {
      label: "Total Price",
      key: "totalPrice",
      cellContent: (row: any) => {
        const isGroup = row?.isGroupTicket;
        const groupCount = row?.groupTicketCount;
        let totalTicketsSold = 0;
        if (isGroup) {
          totalTicketsSold = Number(row?.totalTicketsSold) / Number(groupCount);
        } else {
          totalTicketsSold = row?.totalTicketsSold || 0;
        }
        const price = parseFloat(row?.price) || 0;
        const total = price * totalTicketsSold;
        return <span>{total.toFixed(2)}</span>;
      }
    },
    {
      label: "Is Group Ticket",
      key: "isGroupTicket",
      cellContent: (row: any) => <span>{row.isGroupTicket ? "Yes" : "No"}</span>,
    },
    { label: "Ticket Status", key: "ticketStatus",cellContent: (row: any) => <span className={row.ticketStatus === "active" ? "text-success" : "text-danger"}>{row.ticketStatus.charAt(0).toUpperCase() + row.ticketStatus.slice(1)}</span> },
  ];
  const handleSearch = (e: any) => {
    const search = e.target.value;
    setSearch(search);

    if (search.length > 0) {
      const filteredResults = originalBookingStatus.filter((booking: any) =>
        booking.groupName.toLowerCase().startsWith(search.toLowerCase())
      );
      setBookingStatus(filteredResults);
    } else {
      setBookingStatus(originalBookingStatus);
    }
  };
  {isModalOpen && (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <h5>Buyer Details</h5>
        <button
          className="btn btn-sm btn-danger float-end"
          onClick={() => setIsModalOpen(false)}
        >
          Close
        </button>
  
        <table className="table table-bordered mt-3">
          <thead>
            <tr>
              <th>#</th>
              <th>Buyer Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Tickets</th>
            </tr>
          </thead>
          <tbody>
          {selectedTicketBuyers.map((buyer: any, index: number) => (
  <tr key={buyer.bookingId}>
    <td>{index + 1}</td>
    <td>{buyer.fullName || "N/A"}</td>
    <td>{buyer.email || "N/A"}</td>
    <td>{buyer.phoneNumber || "N/A"}</td>
    <td>{buyer.ticketCount || 1}</td>
  </tr>
))}
          </tbody>
        </table>
      </div>
    </div>
  )}
  
  const exportData = bookingStatus.map((row: any) => {

    const isGroup = row?.isGroupTicket;
    const groupCount = row?.groupTicketCount;
    let totalTicketsSold = 0;
    if (isGroup) {
      totalTicketsSold = Number(row?.totalTicketsSold) / Number(groupCount);
    } else {
      totalTicketsSold = row?.totalTicketsSold || 0;
    }
    const price = parseFloat(row.price) || 0;
    const sold = Number(totalTicketsSold) || 0;
    return {
      groupName: row.groupName || "",
      ticketType: row.ticketType || "",
      Ticketprice: price.toFixed(2),
      TicketsSold: sold,
      isGroupTicket: row.isGroupTicket ? "Yes" : "No",
      ticketStatus: row.ticketStatus || "",
    };
  });

  const onSelectedVenue = async (e: any) => {
    setIsLoading(true);
    const selectedVenue = e.target.value;
    const eventData = localStorage.getItem("eventData");
    if (!eventData) return;
    const eventSlug = JSON.parse(eventData).slugId;
    const response = await getTicketTypeBySlug(eventSlug);
    if(selectedVenue !== "0"){
      const filteredResults = response.filter((booking: any) => booking.venueId === selectedVenue);
      setBookingStatus(filteredResults);
      setOriginalBookingStatus(filteredResults);
    }else{
      setBookingStatus(response);
      setOriginalBookingStatus(response);
    }
    setIsLoading(false);
    setSelectedVenue(selectedVenue);
  }
  const handleGroupSorting = (selectedId:any) => {
    setSelectedGroupSorting(selectedId);
    if (selectedId === "0") {
      setBookingStatus(originalBookingStatus);
    } else {
      const newFiltered = originalBookingStatus.filter((item) =>item.groupingId.toString() === selectedId 
      );
      setBookingStatus(newFiltered);
    }
  };
  return (
    <div className="dashboard-body">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="d-main-title">
              <h3>
                <i className="mx-2">
                  <i className="fa-solid fa-chart-simple "></i>
                </i>
                Ticket Report
              </h3>
            </div>
          </div>
          <div className="col-md-12">
            <div className="main-card mt-5">
              <div className="dashboard-wrap-content p-4">
                <div className="d-md-flex flex-wrap align-items-center">
                  <div className="dashboard-date-wrap mt-1">
                    <div className="form-group">
                    <div className="search-container position-relative d-flex flex-column flex-md-row align-items-center gap-3 p-2">
                    {/* {eventVenues && eventVenues.length > 0 && (
                          <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            <select
                              className="form-control h_40 ps-4 "
                              value={selectedVenue}
                              onChange={(e) => onSelectedVenue(e.target.value)}
                            >
                              {eventVenues.map((venue: any) => (
                                <option key={venue.value} value={venue.value}>
                                  {venue.label}
                                </option>
                              ))}
                            </select>
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2"></i>
                          </div>
                        )} */}
                          {hasGroupTickets && (
                          <div className="search-group position-relative w-100 mb-2 mb-md-0">
                            <select
                              className="form-control h_40 ps-4 "
                              value={selectedGroupSorting}
                              onChange={(e) => handleGroupSorting(e.target.value)}
                            >
                              <option value="0">All Group Tickets</option>
                              {groupTicketList.map((group: any) => (
                                <option key={group.value} value={group.value}>
                                  {group.label}
                                </option>
                              ))}
                            </select>
                            <i className="uil uil-search position-absolute start-0 top-50 translate-middle-y ms-2" ></i>
                          </div>
                        )}
                        <div className="search-group position-relative w-100 mb-2 mb-md-0">
                        <input
                          className="form-control h_40"
                          type="text"
                          placeholder="Search by Group Name"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                        <i className="uil uil-search"></i>
                      </div>

                        <div className="search-group position-relative w-100 mb-2 mb-md-0">
                        <ExportToExcel
                          data={exportData}
                          fileName="Ticket_Report"
                        />
                      </div>
                     </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {isLoading ? (
              <div className="d-flex justify-content-center py-4">
                <PulseLoader
                  color="#ffffff"
                  size={9}
                  speedMultiplier={1}
                />
              </div>
            ) : (
              <div className="event-list">
                <div className="tab-content">
                  <div
                    className="tab-pane fade show active"
                    id="orders-tab"
                    role="tabpanel"
                  >
                    <NormalTable columns={columns} data={bookingStatus} getRowId={(row: any) => row.ticketTypeId} />
                  </div>
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};
export default UserTicketReport;